const shares = document.querySelectorAll('.js-share-text');

if(shares.length) {
  shares.forEach(share => {
    share.addEventListener('click', () => {
      const text = share.getAttribute('data-text');
      if(navigator.share) {
        navigator.share({
          title: document.title,
          text: share.textContent,
          url: text
        });
      }
    });
  });
}